export default __webpack_public_path__ + "static/media/logo-light.9c765146.png";